import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';

interface MarkdownViewProps {
  content: string;
  className?: string;
}

export function MarkdownView({ content, className }: MarkdownViewProps) {
  return (
    <div
      className={`prose prose-invert max-w-none text-sm ${className ?? ''}`}
      style={{
        color: 'var(--tg-text)',
        lineHeight: '1.6',
      }}
    >
      <style>{`
        .prose h1, .prose h2, .prose h3 { color: var(--tg-text); }
        .prose code { background: var(--tg-bg-tertiary); padding: 2px 4px; border-radius: 3px; font-size: 0.85em; }
        .prose pre { background: var(--tg-bg-tertiary); border-radius: 8px; padding: 12px; overflow-x: auto; }
        .prose pre code { background: none; padding: 0; }
        .prose blockquote { border-left: 3px solid var(--tg-accent); padding-left: 12px; color: var(--tg-text-secondary); }
        .prose a { color: var(--tg-accent); }
        .prose table { width: 100%; border-collapse: collapse; }
        .prose th, .prose td { border: 1px solid var(--tg-border); padding: 6px 10px; }
        .prose th { background: var(--tg-bg-tertiary); }
        .prose hr { border-color: var(--tg-border); }
      `}</style>
      <ReactMarkdown rehypePlugins={[rehypeHighlight]}>{content}</ReactMarkdown>
    </div>
  );
}
